var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolunteer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6014 14.429L17.3242 12.7875C17.3776 12.7638 17.4314 12.7529 17.4839 12.7529C17.7586 12.7529 17.9995 13.0556 17.9995 13.4567C17.9995 13.7098 17.8996 13.9437 17.7378 14.0685L12.4489 18.1493C11.2192 19.098 9.74563 19.2618 8.41905 18.5972L5.65997 17.2143L3.28516 17.2312V12.661H6.13747C7.3628 11.8903 8.78962 12.0005 9.94345 12.9541L10.3344 13.2773H12.756C12.9896 13.2773 13.2007 13.4061 13.3538 13.6146C13.5068 13.8231 13.6014 14.1112 13.6014 14.429Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38851 18.2222H4.70866C5.07996 18.2222 5.38096 17.9051 5.38096 17.5139V12.7083C5.38096 12.3171 5.07996 12 4.70866 12H1.38851C1.17396 12 1 12.1832 1 12.4093V17.8129C1 18.039 1.17392 18.2222 1.38851 18.2222Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1777 13.7161C13.3233 13.9053 13.4132 14.1667 13.4132 14.455C13.4132 15.0321 13.0531 15.5 12.6091 15.5H9.74799H6.8418V12.5926C7.87484 12.1977 8.99848 12.3794 9.93362 13.1167L10.3055 13.41H12.6091C12.8312 13.41 13.0321 13.5269 13.1777 13.7161Z",
    fill: "#0083FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6392_24082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 12,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9991 4.18172C19.0415 2.46967 17.6149 1.0188 15.8182 1.00019C14.6153 0.987712 13.563 1.60489 13 2.52694C12.4369 1.60489 11.3847 0.98761 10.1818 1.00019C8.38508 1.0188 6.95854 2.46967 7.00092 4.18172C7.09577 8.00744 11.8965 11.335 12.84 11.9526C12.9365 12.0158 13.0635 12.0158 13.16 11.9526C14.1035 11.335 18.9042 8.00744 18.9991 4.18172Z",
    fill: "#C7E3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6392_24082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9991 4.18172C19.0415 2.46967 17.6149 1.0188 15.8182 1.00019C14.6153 0.987712 13.563 1.60489 13 2.52694C12.4369 1.60489 11.3847 0.98761 10.1818 1.00019C8.38508 1.0188 6.95854 2.46967 7.00092 4.18172C7.09577 8.00744 11.8965 11.335 12.84 11.9526C12.9365 12.0158 13.0635 12.0158 13.16 11.9526C14.1035 11.335 18.9042 8.00744 18.9991 4.18172Z",
    fill: "#0083FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteer);
export default __webpack_public_path__ + "static/media/volunteer.8d0a930e.svg";
export { ForwardRef as ReactComponent };